import { render, staticRenderFns } from "./AdvancedResourceList.vue?vue&type=template&id=91c4cd7c&"
import script from "./AdvancedResourceList.vue?vue&type=script&lang=js&"
export * from "./AdvancedResourceList.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedResourceList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer})
